/**
 * Meta Pixel (Facebook) Consent Integration
 * 
 * This module handles Meta Pixel consent using their official consent API.
 * 
 * @see https://developers.facebook.com/docs/meta-pixel/implementation/gdpr
 */

// Extend window type for fbq
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Grant consent to Meta Pixel
 * Allows Pixel to fire events and set cookies
 */
export function grantMetaConsent(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('consent', 'grant');
  }
}

/**
 * Revoke consent from Meta Pixel
 * Stops Pixel from firing events and setting cookies
 */
export function revokeMetaConsent(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('consent', 'revoke');
  }
}

/**
 * Update Meta Pixel consent based on marketing consent state
 */
export function updateMetaConsent(marketingConsented: boolean): void {
  if (marketingConsented) {
    grantMetaConsent();
  } else {
    revokeMetaConsent();
  }
}

/**
 * Check if Meta Pixel is loaded
 */
export function isMetaPixelLoaded(): boolean {
  return typeof window.fbq === 'function';
}

/**
 * Initialize Meta Pixel with consent state
 * Should be called after Pixel script loads (via GTM)
 */
export function initializeMetaConsent(marketingConsented: boolean): void {
  // If Pixel isn't loaded yet, it will respect dataLayer consent signals from GTM
  // When it does load, we update its consent state
  if (isMetaPixelLoaded()) {
    updateMetaConsent(marketingConsented);
  }
}

